import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/2.jpg'
import timg5 from '../images/team/img-5.jpg'
import timg6 from '../images/team/img-6.jpg'
import timg7 from '../images/team/img-7.jpg'
import timg8 from '../images/team/img-8.jpg'


import Stime1 from '../images/team-single/1.jpg'
import Stime2 from '../images/team-single/2.jpg'
import Stime3 from '../images/team-single/3.jpg'
import Stime4 from '../images/team-single/4.jpg'
import Stime5 from '../images/team-single/5.jpg'
import Stime6 from '../images/team-single/6.jpg'
import Stime7 from '../images/team-single/7.jpg'
import Stime8 from '../images/team-single/8.jpg'


const Teams = [
    {
        id: '1',
        title: 'Robert Fox',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox',
        timg: timg1,
        Sime: Stime1,
    },
    {
        id: '2',
        title: 'Harvard Bunion',
        subtitle: 'Partner & CEO',
        slug: 'Harvard-Bunion',
        timg: timg2,
        Sime: Stime2,
    },
    {
        id: '3',
        title: 'Benzamin Simon',
        subtitle: 'Interior Designer',
        slug: 'Interior-Designer',
        timg: timg3,
        Sime: Stime3,
    },
    {
        id: '4',
        title: 'Robert Fox',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox',
        timg: timg4,
        Sime: Stime4,
    },
    {
        id: '5',
        title: 'Wade Warren',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox5',
        timg: timg5,
        Sime: Stime5,
    },
    {
        id: '6',
        title: 'Esther Howard',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox6',
        timg: timg6,
        Sime: Stime6,
    },
    {
        id: '7',
        title: 'Robert Willum',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox7',
        timg: timg7,
        Sime: Stime7,
    },
    {
        id: '8',
        title: 'Guy Hawkins',
        subtitle: 'Senior Architect',
        slug: 'Robert-Fox8',
        timg: timg8,
        Sime: Stime8,
    },


]

export default Teams;



